'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FileFolderOpen = function FileFolderOpen(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V8h16v10z' })
  );
};
FileFolderOpen = (0, _pure2.default)(FileFolderOpen);
FileFolderOpen.displayName = 'FileFolderOpen';

exports.default = FileFolderOpen;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/file/folder-open.js
 ** module id = 1492
 ** module chunks = 0
 **/